
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/topic/[category]/[idx]",
      function () {
        return require("private-next-pages/blog/topic/[category]/[idx].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/topic/[category]/[idx]"])
      });
    }
  